import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { apiEndpoints } from "../../services/apiConfig"; // adjust path if needed

export const createQuotation = createAsyncThunk(
  "orders/createQuotation",
  async (payload, { rejectWithValue }) => {
    try {
      // Get token from localStorage
      const token = localStorage.getItem("token"); // replace "token" if your key is different

      const response = await axios.post(apiEndpoints.createProforma, payload, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      return response.data;
    } catch (error) {
      // Capture API or network errors
      return rejectWithValue(
        error.response?.data || { detail: "Something went wrong" },
      );
    }
  },
);

export const downloadInvoice = createAsyncThunk(
  "orders/downloadInvoice",
  async (id, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("token");

      // Use axios with explicit configuration
      const response = await axios({
        method: "get",
        url: apiEndpoints.downloadPdf.replace("{quotation_id}", id),
        headers: {
          Authorization: `Bearer ${token}`,
        },
        responseType: "blob", // This ensures we get a blob
      });

      return response.data;
    } catch (error) {
      // Handle error
      if (error.response?.data instanceof Blob) {
        const text = await error.response.data.text();
        try {
          const errorData = JSON.parse(text);
          return rejectWithValue(errorData.message || "Download failed");
        } catch {
          return rejectWithValue("Download failed");
        }
      }
      return rejectWithValue(
        error.response?.data?.message || "Something went wrong",
      );
    }
  },
);

// ✅ Slice definition
const quotationSlice = createSlice({
  name: "quotation",
  initialState: {
    loading: false,
    success: false,
    error: null,
    quotationResponse: null,
    downloadInvoiceResponse: null,
    chatHistoryResponse: [],
  },
  reducers: {
    pushMessage: (state, action) => {
      state.chatHistoryResponse.push(action.payload);
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(createQuotation.pending, (state) => {
        state.loading = true;
        state.success = false;
        state.error = null;
      })
      .addCase(createQuotation.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.quotationResponse = action.payload;
      })
      .addCase(createQuotation.rejected, (state, action) => {
        state.loading = false;
        state.success = false;
        state.error = action.payload?.detail || "Submission failed";
      })
      .addCase(downloadInvoice.pending, (state) => {
        state.loading = true;
        state.success = false;
        state.error = null;
      })
      .addCase(downloadInvoice.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.downloadInvoiceResponse = action.payload;
      })
      .addCase(downloadInvoice.rejected, (state, action) => {
        state.loading = false;
        state.success = false;
        state.error = action.payload?.detail || "Submission failed";
      });
  },
});

export default quotationSlice.reducer;
